document.addEventListener('DOMContentLoaded', function() {
  var initialized = false;

  function initChoiceButtons() {
    var buttons = document.querySelectorAll('.campaign-choice-button');

    buttons.forEach(function(button) {
      button.addEventListener('click', function() {
        var redirectUrl = this.getAttribute('data-redirect-url');

        if (redirectUrl) {
          window.location.href = redirectUrl;
        }
      });
    });
  }

  function initCopyCoupon() {
    var btn = document.getElementById('copyCouponBtn');
    if (!btn) return;

    var coupon = btn.getAttribute('data-coupon') || '';
    var textEl = document.getElementById('copyCouponText');

    btn.addEventListener('click', function() {
      if (!coupon) return;

      function done() {
        if (textEl) textEl.textContent = 'Copiado!';
        btn.classList.add('copied');
        setTimeout(function() {
          if (textEl) textEl.textContent = 'Copiar cupom';
          btn.classList.remove('copied');
        }, 2000);
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(coupon).then(done).catch(function() {
          fallbackCopy(coupon, done);
        });
      } else {
        fallbackCopy(coupon, done);
      }
    });
  }

  function fallbackCopy(code, onSuccess) {
    var ta = document.createElement('textarea');
    ta.value = code;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();

    try {
      if (document.execCommand('copy')) onSuccess();
    } catch (e) {}

    document.body.removeChild(ta);
  }

  function init() {
    if (initialized) return;
    initialized = true;

    initChoiceButtons();
    initCopyCoupon();
  }

  function startCardsGame() {
    var quiz = document.getElementById('cardsQuizForm');
    var game = document.getElementById('cardsGame');

    if (quiz) quiz.classList.add('hidden');

    if (game) {
      game.classList.remove('hidden');
      init();
    }
  }

  var params = new URLSearchParams(window.location.search);
  if (window.cardsFormSuccess || params.get('customer_posted') === 'true') {
    startCardsGame();
  }

  var gameEl = document.getElementById('cardsGame');
  if (gameEl && !gameEl.classList.contains('hidden')) {
    init();
  }
});
